const fb = require('@/firebaseConfig.js')
const jwt = require('jsonwebtoken')

const state = {
  profile: {
    userIsAnonymous: false,
    userEmail: '',
    displayName: null,
    photoURL: null,
    userId: '',
    userTier: null,
    userApiToken: null,
    emailVerified: false,
    loginProvider: '',
    creationTime: undefined,
    lastSignInTime: undefined
  }
}
const getters = {
  displayName: state => {
    if (state.profile.displayName) return state.profile.displayName
    else return state.profile.userEmail
  },
  getUserAvatar: state => {
    if (state.profile.photoURL) return state.profile.photoURL
    else return require('@/assets/_img/avatar_default.jpg')
  },
  currentUser: state => {
    return state.profile
  }
}
const actions = {
  setCurrentUser ({ commit, state }, user) {
    console.log(user)
    if (user) {
      if (user.isAnonymous) {
        commit('updateUserProfile', { key: 'displayName', value: 'Guest' })
        commit('updateUserProfile', { key: 'loginProvider', value: 'guest' })
      } else {
        commit('updateUserProfile', { key: 'userEmail', value: user.email })
        commit('updateUserProfile', { key: 'emailVerified', value: user.emailVerified })
        commit('updateUserProfile', { key: 'displayName', value: user.displayName })
        commit('updateUserProfile', { key: 'photoURL', value: user.photoURL })
        commit('updateUserProfile', { key: 'loginProvider', value: user.providerData[0].providerId })
      }
      commit('updateUserProfile', { key: 'userId', value: user.uid })
      commit('updateUserProfile', { key: 'userIsAnonymous', value: user.isAnonymous })
      commit('updateUserProfile', { key: 'creationTime', value: parseInt(user.metadata.a) })
      commit('updateUserProfile', { key: 'lastSignInTime', value: parseInt(user.metadata.b) })
      fb.auth.currentUser.getIdToken(/* forceRefresh */ true)
        .then((idToken) => {
          let apiToken = fb.functions.httpsCallable('auth/api_tokens/issue', idToken)
          apiToken().then((result) => {
            commit('updateUserProfile', { key: 'userApiToken', value: result.data })
            commit('updateUserProfile', { key: 'userTier', value: jwt.decode(result.data).tier })
          })
        })
    }
  }
}
const mutations = {
  updateUserProfile (state, el) {
    Reflect.set(state.profile, el.key, el.value)
  },
  resetUser (state) {
    state.profile = {
      userIsAnonymous: false,
      userEmail: '',
      displayName: null,
      photoURL: null,
      userId: '',
      userTier: null,
      userApiToken: null,
      emailVerified: false
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
